import { render, staticRenderFns } from "./LinksGroup.vue?vue&type=template&id=0988b981&scoped=true&"
import script from "./LinksGroup.vue?vue&type=script&lang=js&"
export * from "./LinksGroup.vue?vue&type=script&lang=js&"
import style0 from "./LinksGroup.vue?vue&type=style&index=0&id=0988b981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988b981",
  null
  
)

export default component.exports